import { Helmet } from 'react-helmet-async'
import Section from '../components/common/Section'
import ContactForm from '../components/contact/ContactForm'
import ContactInfo from '../components/contact/ContactInfo'

export default function KontaktPage() {
  return (
    <>
      <Helmet>
        <title>Kontakt - Gabriele Wiedemann</title>
        <meta
          name="description"
          content="Kontaktieren Sie Gabriele Wiedemann für Anfragen zu Kunstwerken und Ausstellungen."
        />
        <meta property="og:title" content="Kontakt - Gabriele Wiedemann" />
        <meta property="og:description" content="Nehmen Sie Kontakt auf für Anfragen zu Kunstwerken" />
        <meta property="og:type" content="website" />
      </Helmet>

      <Section background="white" padding="large">
        <div className="max-w-6xl mx-auto">
          {/* Page Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-serif text-primary mb-4">Kontakt</h1>
            <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
              Ich freue mich auf Ihre Nachricht. Ob Fragen zu Kunstwerken, Ausstellungen oder
              Auftragsarbeiten – nehmen Sie gerne Kontakt auf.
            </p>
          </div>

          {/* Contact Content */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Contact Form */}
            <div>
              <ContactForm />
            </div>

            {/* Contact Info */}
            <div>
              <ContactInfo />
            </div>
          </div>
        </div>
      </Section>
    </>
  )
}
